import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { SearchSchema } from './-schema';

export const Route = createFileRoute(
  '/_staff/people/_list/settings/retirement-reasons/',
)({
  validateSearch: zodValidator(SearchSchema),
});
